import React from "react";
import TextField from "../../../../Forms/TextField";
import DropDown from "../../../../Forms/DropDown";
import TextCKEditor from "../../../../Forms/TextCKEditor";
import { Image, Text } from "@fluentui/react";
import { useFormikContext } from "formik";
import InfoLabelButton from "../../../../Forms/InfoLabelButton";

const thirdPartyCompletionMechanismsOptions = [
  {
    key: "Self-reported",
    text: "Self-reported",
  },
  {
    key: "Client-reported",
    text: "Client-reported",
  },
];

const ThirdPartyFields = () => {
  const { getFieldProps, setFieldValue } = useFormikContext();
  return (
    <>
      <DropDown
        label="Completion Mechanism"
        placeholder="Select an option"
        options={thirdPartyCompletionMechanismsOptions}
        name="thirdPartyCompletionMechanism"
      />
      <div>
        <label className="default-label">User Facing Action Title</label>
        <Text variant="xSmall" styles={{ root: { color: "#605e5c", display: "block", marginBottom: 4 } }}>(supports HTML formatting)</Text>
        <TextCKEditor
          value={getFieldProps("thirdPartyActionTitle").value || ""}
          onChange={(val) => setFieldValue("thirdPartyActionTitle", val)}
        />
      </div>

      <div>
        <InfoLabelButton
          label="How It Works"
          calloutChildren={
            <img
              src="https://igradcdnproduction.blob.core.windows.net/images/admin_portal/ThirdPartyHowItWorks.png"
              alt=""
              height={300}
              width={540}
            />
          }
        />
        <Text variant="xSmall" styles={{ root: { color: "#605e5c", display: "block", marginBottom: 4 } }}>(supports HTML formatting)</Text>
        <TextCKEditor
          value={getFieldProps("thirdPartyHowItWorks").value || ""}
          onChange={(val) => setFieldValue("thirdPartyHowItWorks", val)}
        />
        <Text variant="xSmall">
          This should explain the step by step process the user needs to do off site to complete the action. It can/should include links off site when needed.
        </Text>
      </div>

      <Text variant="xSmall">
        (If you need to include images, upload to the CDN and insert the link
        here)
      </Text>

      {getFieldProps("thirdPartyCompletionMechanism").value ===
        thirdPartyCompletionMechanismsOptions[1].key && (
        <>
          <div>
            <InfoLabelButton
              label="How to Complete"
              calloutChildren={
                <Image
                  src="https://igradcdnproduction.blob.core.windows.net/images/admin_portal/ThirdPartyHowToComplete.png"
                  alt=""
                  height={300}
                  width={540}
                />
              }
            />
            <Text variant="xSmall" styles={{ root: { color: "#605e5c", display: "block", marginBottom: 4 } }}>(supports HTML formatting)</Text>
            <TextCKEditor
              value={getFieldProps("thirdPartyHowToComplete").value || ""}
              onChange={(val) => setFieldValue("thirdPartyHowToComplete", val)}
            />
            <Text variant="xSmall">
              This should explain how the client-reported completion works, giving user an estimated turnaround time.
            </Text>
          </div>

          <Text variant="xSmall">
            (If you need to include images, upload to the CDN and insert the
            link here)
          </Text>
        </>
      )}
    </>
  );
};

export default ThirdPartyFields;
